import fetch, { NewAxiosRequestConfig } from '@/utils/axios';

/**
 * 获取上报token
 * @param config
 */
export const getTrackSession = (source, url, config?: NewAxiosRequestConfig): Promise<AResponse> => {
  return fetch.get('/ec/tracking/session_id', { source, url }, config);
};
